import styled from "styled-components";
const LegendBox = styled.div`
  flex: 0 0 100%;
  padding: 1em;
  height: 300px;
  text-align: ${(props) =>
    props.center ? "center" : props.align ? props.align : "left"};
  @media (min-width: 40em) {
    flex: ${(props) => (props.width ? `0 0 ${props.width}` : 1)};
    width: ${(props) => (props.width ? props.width : "100%")};
  }
  /* Moto G4 & Microsoft Lumia 950 & Microsoft Lumia 550 & Galaxy S3 & Galaxy Note 2 & Galaxy Note 3 */
  @media only screen and (device-width: 360px) and (device-height: 640px) {
  }
`;

export default LegendBox;
